import { useMutation } from "react-query";
import { DocumentReference, updateDoc } from "firebase/firestore";
import { GameStatus } from "./Game";
import { useSelector } from "../../../redux/store";

export const useSetStatusToPlayMutation = ({
  gameRef,
}: {
  gameRef: DocumentReference;
}) => {
  const game = useSelector((state) => state.game.game);
  return useMutation(async () => {
    const members = Object.values(game?.membersMap ?? []);

    const updateObject: Record<string, any> = {
      status: GameStatus.PLAY,
      activePlayerId: members[0].userId,
    };

    await updateDoc(gameRef, updateObject);
  });
};
